import { grey } from '@mui/material/colors';

const styles = {
  footer: {
    display: 'flex',
    width: '100%',
    minHeight: '8rem',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: grey[900],
  },
};

export default styles;